import React, { useState, useMemo, useCallback, useEffect } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { useDebounce } from "@/hooks/useDebounce";
import { LEAD_STAGES } from "@/constants/globalConstants";
import { useUIStore } from "@/store/uiStore";
import { useAuthStore } from "@/store/authStore";

export const useLeadFilters = () => {
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  
  const [view, setView] = useState("table");
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("-createdAt");
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuthStore();
  
  const isPMUser = user?.role === 'designer';
  const defaultTab = isPMUser ? 'site_visit' : 'all';
  const initialTab = searchParams.get('tab') || defaultTab;

  const [filters, setFilters] = useState({
    status: initialTab,
    activityStatus: "all",
    source: "all",
    city: "all",
    assignedTo: "all",
    serviceType: "all",
    date: "all",
    fromDate: "",
    toDate: ""
  });

  // Sync URL changes to state
  useEffect(() => {
    const currentTab = searchParams.get("tab") || 'all';
    setFilters(prev => {
      if (prev.status === currentTab) return prev;
      return {
        ...prev,
        status: currentTab,
      };
    });
  }, [searchParams]);
//updated by: Halimunnisa 09-06-2026
  // Update UI Store with current tab label
  React.useEffect(() => {
    if (location.pathname === '/leads') {
      const activeTab = searchParams.get("tab") || 'all';
      if (activeTab && activeTab !== 'all') {
        const stage = LEAD_STAGES.find(s => s.key === activeTab);
        if (stage) {
          useUIStore.getState().setPageTitle(stage.label);
        } else {
          useUIStore.getState().setPageTitle('Lead Management');
        }
      } else {
        useUIStore.getState().setPageTitle('Lead Management');
      }
    }
  }, [searchParams, location.pathname]);

  // Clean up store on unmount
  React.useEffect(() => {
    return () => {
      useUIStore.getState().setPageTitle(null);
    };
  }, []);

  const handleFilterChange = useCallback((key, value) => {
    if (typeof key === 'object') {
      setFilters(prev => ({ ...prev, ...key }));
    } else {
      setFilters(prev => ({ ...prev, [key]: value }));
    }
    setPage(1);
  }, []);
//updated by: Halimunnisa 09-06-2026
  return {
    search, setSearch,
    debouncedSearch,
    view, setView,
    page, setPage,
    sortBy, setSortBy,
    filters, 
    setFilters: handleFilterChange,
    showAdvancedFilters, setShowAdvancedFilters,
    activeTab: searchParams.get("tab") || defaultTab,
    setSearchParams
  };
};
